module.exports = __webpack_public_path__ + "img/协会伙伴logo@2x.3817be68.png";